<template>
  <div class="w-100 h-100 flex flex-column">
    <dv-border-box-12>
      <div class="h-100">
        <div class="w-100 h-100 p-tb" id="deptTimelyRate"></div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
export default {
  name: "deptTimelyAttendRate",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dataList: this.beans,
      startCharts: null,
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },

    lineEchart() {
      var lineEchart = this.$echarts.init(
        document.getElementById("deptTimelyRate")
      );

      var data = this.dataList;

      const xAxis = [];
      const barData = [];
      const plannedCount = [];
      const actualCount = [];
      data.forEach((item) => {
        xAxis.push(item.title);
        plannedCount.push(item.count);
        actualCount.push(item.closeCount);
        if (item.count == 0) {
          barData.push(0);
        } else {
          barData.push(item.rate);
        }
      });

      var option = {
        title: {
          text: "部门及时率",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: this.fontSize(0.22),
          },
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        grid: {
          y2: 20,
          bottom: 35,
        },
        legend: {
          data: ["已关闭问题", "及时关闭", "及时率"],
          right: 0,
          textStyle: {
            color: "#ffffff", //字体颜色
            fontSize: this.fontSize(0.10),
          },
          itemGap: 2,
          itemWidth: 12,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: this.fontSize(0.14),
              },
              interval: 0,
              rotate: 18
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "已关闭问题",
            min: 0,
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "及时率",
            min: 0,
            axisLabel: {
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            color: ["#CCCCCC"],
            name: "已关闭问题",
            type: "bar",
            data: plannedCount,
            barGap: "-100%", // Make series be overlap
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#CCCCCC",
                    fontSize: this.fontSize(0.14),
                  },
                },
              },
            },
          },
          {
            color: ["#3398DB"],
            name: "及时关闭",
            type: "bar",
            data: actualCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#3398DB",
                    fontSize: this.fontSize(0.14),
                  },
                },
              },
            },
          },
          {
            name: "及时率",
            type: "line",
            yAxisIndex: 1,
            data: barData,
            itemStyle: {
              normal: { //改变折线点的颜色
                lineStyle: {
                  color: "#F25346", //改变折线颜色
                },
              },
            },
          },
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

      if (this.startCharts) {
        clearInterval(this.startCharts);
      }

      var index = 0; //显示tooltip,播放所在下标
      this.startCharts = setInterval(function () {
        lineEchart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= data.length) {
          index = 0;
        }
      }, 2000);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.4rem 0.2rem;
}

/*左边中间部分排行榜*/
.biaoge_pai {
  overflow: hidden;
}

.biaoge_pai ul li {
  height: 20%;
}

.biaoge_pai ul li .liIn {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  color: #fff;
  font-size: 0.06rem;
  height: 0.6rem;
}

.biaoge_pai ul li .liIn .liIn_left {
  width: 25%;
  position: relative;
  padding-left: 0.3rem;
}

.biaoge_pai ul li .liIn .liIn_left .bot {
  width: 0.2rem;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 1000px;
  display: block;
  position: absolute;
  left: 0.02rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.biaoge_pai ul li .liIn2 .liIn_left .bot {
  background: #e7feb8;
}

.biaoge_pai ul li .liIn3 .liIn_left .bot {
  background: #fdea8a;
}

.biaoge_pai ul li .liIn4 .liIn_left .bot {
  background: #8ff9f8;
}

.biaoge_pai ul li .liIn5 .liIn_left .bot {
  background: #91cc75;
}

.biaoge_pai ul li .liIn6 .liIn_left .bot {
  background: #05d1fc;
}

.biaoge_pai ul li .liIn .liIn_line {
  width: 58%;
  height: 0.2rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2000px;
}

.biaoge_pai ul li .liIn .liIn_line .line_lineIn {
  width: 100%;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 100px;
  -webkit-animation: widthMove1 2s ease-in-out;
}

.biaoge_pai ul li .liIn2 .liIn_line .line_lineIn {
  background: #e7feb8;
  -webkit-animation: widthMove2 2s ease-in-out;
}

.biaoge_pai ul li .liIn3 .liIn_line .line_lineIn {
  background: #fdea8a;
  -webkit-animation: widthMove3 2s ease-in-out;
}

.biaoge_pai ul li .liIn4 .liIn_line .line_lineIn {
  background: #8ff9f8;
  -webkit-animation: widthMove4 2s ease-in-out;
}

.biaoge_pai ul li .liIn5 .liIn_line .line_lineIn {
  background: #d890fa;
  -webkit-animation: widthMove5 2s ease-in-out;
}

.biaoge_pai ul li .liIn6 .liIn_line .line_lineIn {
  background: #05d1fc;
  -webkit-animation: widthMove6 2s ease-in-out;
}

@-webkit-keyframes widthMove1 {
  0% {
    width: 0%;
  }

  100% {
    width: 98.5%;
  }
}

@-webkit-keyframes widthMove2 {
  0% {
    width: 0%;
  }

  100% {
    width: 88.5%;
  }
}

@-webkit-keyframes widthMove3 {
  0% {
    width: 0%;
  }

  100% {
    width: 68.5%;
  }
}

@-webkit-keyframes widthMove4 {
  0% {
    width: 0%;
  }

  100% {
    width: 40.5%;
  }
}

@-webkit-keyframes widthMove5 {
  0% {
    width: 0%;
  }

  100% {
    width: 22.5%;
  }
}

@-webkit-keyframes widthMove6 {
  0% {
    width: 0%;
  }

  100% {
    width: 10.5%;
  }
}

.biaoge_pai ul li .liIn .num {
  font-family: dig;
  padding-left: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/fr/report/a3/component/issue-cause.vue